import diploma from "../images/diploma.png";

const Certificate = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "fit-content",
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <figure>
        <img src={diploma} alt="certificate-maia-kiknavelidze" />
      </figure>
    </div>
  );
};

export default Certificate;
